module.exports = __webpack_public_path__ + "catalog/items/fireplace/fireplace.svg";